import { Component, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: '[mcraiModal], [mcrai-modal], mcrai-modal',
  template: `<ng-content></ng-content>`,
  styles: [`.mcrai-modal{display:flex;flex-direction:column;align-items:stretch;height:100%}.mcrai-modal__header{display:flex;justify-content:flex-start;align-items:center;padding:0 20px;height:65px;margin-bottom:-1px}.mcrai-modal__content{display:block;padding:20px;flex:1;overflow-y:auto;overflow-x:hidden}.mcrai-modal__actions{display:flex;justify-content:flex-end;align-items:center;padding:0 20px;height:65px;margin-top:-1px}`],
  animations: [
    trigger('scale', [
      state('in', style({ opacity: 1, transform: 'scaleY(1)' })),
      transition(':enter', [
        style({ opacity: 0, transform: 'scaleY(0)' }),
        animate(`225ms cubic-bezier(0.4,0.0,1,1)`)
      ]),
      transition(':leave', [
        style({ opacity: 0, transform: 'scaleY(0)' }),
        animate(`225ms cubic-bezier(0.0,0.0,0.2,1)`)
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
  host: {
    '[class.mcrai-modal]': 'true'
  }
})
export class McRAIModalComponent implements OnInit {
  @HostBinding('@scale') _animation: any = true;

  constructor() { }

  ngOnInit() { }

}
